/* tslint:disable */
/* eslint-disable */
/* @relayHash ccc29137fd4a41d642701fd72c389a04 */

import { ConcreteRequest } from "relay-runtime";
export type BadgesConfigContainerLoadAllBadgesQueryVariables = {};
export type BadgesConfigContainerLoadAllBadgesQueryResponse = {
    readonly allSiteBadgeRules: ReadonlyArray<{
        readonly siteID: string;
        readonly badges: ReadonlyArray<{
            readonly badge: string;
            readonly startDate: string | null;
            readonly endDate: string | null;
        }>;
    }>;
};
export type BadgesConfigContainerLoadAllBadgesQuery = {
    readonly response: BadgesConfigContainerLoadAllBadgesQueryResponse;
    readonly variables: BadgesConfigContainerLoadAllBadgesQueryVariables;
};



/*
query BadgesConfigContainerLoadAllBadgesQuery {
  allSiteBadgeRules {
    siteID
    badges {
      badge
      startDate
      endDate
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "SiteBadgeRulesResult",
            "kind": "LinkedField",
            "name": "allSiteBadgeRules",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "siteID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "BadgeRule",
                    "kind": "LinkedField",
                    "name": "badges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "badge",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "BadgesConfigContainerLoadAllBadgesQuery",
            "selections": (v0 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "BadgesConfigContainerLoadAllBadgesQuery",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "id": "ccc29137fd4a41d642701fd72c389a04",
            "metadata": {},
            "name": "BadgesConfigContainerLoadAllBadgesQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '07d0e15bbe4cb14bc496885c6bd8ac3b';
export default node;
